import { React } from "react";

import Footer from "../Footer";

// IMAGES FOR PAGE
import perfSect2ImgSm from "../../assets/performances/LandOfTheSweets2027/LandOfTheSweets2027Poster-300.png";
import perfSect2ImgMd from "../../assets/performances/LandOfTheSweets2027/LandOfTheSweets2027Poster-768.png";
import perfSect2ImgLg from "../../assets/performances/LandOfTheSweets2027/LandOfTheSweets2027Poster-1280.png";
import perfSect2ImgXL from "../../assets/performances/LandOfTheSweets2027/LandOfTheSweets2027Poster-2000.png";
import handbookLink from "../../assets/performances/LandOfTheSweets2027/LandOfTheSweetsHandbook2027.pdf";
import castList from "../../assets/performances/LandOfTheSweets2027/LandOfTheSweetsCastList.pdf";
import rehearsalSchedule from "../../assets/performances/LandOfTheSweets2027/LandOfTheSweetsRehearsalSchedule.pdf";
import rehearsalReqs from "../../assets/performances/LandOfTheSweets2027/LandOfTheSweets2027CostumeReqs.pdf";
import musicalScore from "../../assets/performances/LandOfTheSweets2027/LandOfTheSweets2027MusicalScore.pdf";
import videos from "../../assets/performances/LandOfTheSweets2027/LandoftheSweets2027VideoOrders.png";
import magazine from "../../assets/performances/LandOfTheSweets2027/Land of the Sweets2027MagazineOrders.pdf";
import shirts from "../../assets/performances/LandOfTheSweets2027/TheLandoftheSweets2027T-Shirts.png";
import photos from "../../assets/performances/LandOfTheSweets2027/Land of the Sweets 2027 Photo Packages.pdf";
import costumeReqs from "../../assets/performances/LandOfTheSweets2027/LandoftheSweets2027-CostumeReqs.pdf";
import programLink from "../../assets/performances/SleepingBeauty2026/TheSleepingBeauty2026Program.pdf";

import PerformanceTemplate from "./templates/PerformanceTemplate";

import "./LandOfSweets2027.css";

function LandOfSweets2027() {
  const status = "ACTIVE";
  const showName = "Land of the Sweets";
  const showDate = "January 30, 2027";
  const headerDescription = `Step into a world of holiday magic with Nylia Ballet Company’s original twist on the classic, The Nutcracker.
  Follow Clara and Marie on an unforgettable journey filled with enchanted toys, a daring battle against the Mouse Queen, and a breathtaking adventure through the Land of the Sweets.
  
  Don’t miss the magic. Get your tickets now!`;
  const program = programLink;
  const handbook = handbookLink;

  const auditionDate = "AUGUST 16, 2026";
  const perfSect2ButtonLink =
    "https://www.ticketmaster.com/land-of-the-sweets-el-paso-texas-01-30-2027/event/0C006536062E8731"; // AUDITION LINK/PROGRAM
  const perfSect2Images = {
    sm: perfSect2ImgSm,
    md: perfSect2ImgMd,
    lg: perfSect2ImgLg,
    xl: perfSect2ImgXL,
  };

  const importantLinks = [
    { buttonLabel: "Cast list", buttonLink: castList },

    {
      buttonLabel: "rehearsal schedule",
      buttonLink: rehearsalSchedule,
    },
    {
      buttonLabel: "Musical Score",
      buttonLink: musicalScore,
    },
    {
      buttonLabel: "Rehearsal Attire",
      buttonLink: rehearsalReqs,
    },
    {
      buttonLabel: "photo packages",
      buttonLink: photos,
    },
    {
      buttonLabel: "shirt orders",
      buttonLink: shirts,
    },
    {
      buttonLabel: "video orders",
      buttonLink: videos,
    },
    {
      buttonLabel: "magazine orders",
      buttonLink: magazine,
    },
    { buttonLabel: "Costume Requirements", buttonLink: costumeReqs },
    // { buttonLabel: "volunteers", buttonLink: "" }, //todo
  ];

  const eventCalendar = [
    {
      eventName: "Auditions",
      date: "08/16/26",
      title: "Land of the Sweets Auditions",
      subtitle: "August 16, 2025",
      caption: "Auditions are held at Nylia Ballet Academy",
      buttonLink: "https://form.jotform.com/262045620084147",
      buttonLabel: "Register for Auditions",
    },
    {
      eventName: "Rehearsals Begin",
      date: "08/31/26",
      caption: "All rehearsals are held at Nylia Ballet Academy.",
    },
    {
      eventName: "Costume Measurements",
      date: "08/31/26",
      caption:
        "Costume measurements will be taken during the dancer's rehearsal from August 31 - September 5.",
    },
    {
      eventName: "Performance Fees Due",
      date: "09/05/26",
      title: "Performance Fees Due",
      caption: "Take a look at our handbook for detailed information!",
    },
    {
      eventName: "Rehearsal Attire Orders Due",
      date: "09/12/26",
      caption:
        "Role-specific rehearsal attire orders are due. This includes rehearsal tutus, skirts, character shoes, and more. ",
    },
    {
      eventName: "Rehearsal Attire Required",
      date: "09/14/26",
      title: "Role-Specific Rehearsal Attire Required",
      caption:
        "All dancers must be wearing their designated rehearsal attire to all rehearsals. The rehearsal attire depends on their role in the production.",
    },
    {
      eventName: "Costume Fees Due",
      date: "09/19/26",
      title: "Costume Fees Due",
      caption: "Take a look at our handbook for detailed information!",
    },
    {
      eventName: "Cast Photoshoot",
      date: "10/25/26",
      title: "Land of the Sweets Cast Photoshoot",
      caption:
        "Picture packages can be purchased at the front desk. Make the beautiful memories last a lifetime!",
    },
    {
      eventName: "Full Run-Throughs (ALL CAST)",
      date: "01/25/27",
      title: "Full Run-Throughs (ALL CAST)",
      subtitle: "January 25 - 29",
      caption:
        "All dancers will be rehearsing and doing full run-throughs of the show daily. Full details can be found in our Handbook.",
    },
    {
      eventName: "Dress Rehearsal",
      date: "01/30/27",
      title: "Land of the Sweets Dress Rehearsal",
      subtitle: "January 30",
      caption:
        "Dress rehearsal will take place at UTEP's Magoffin Auditorium. Full details can be found in the Land of the Sweets Handbook.",
    },
    {
      eventName: "Nylia Ballet Company's Land of the Sweets",
      date: "01/30/27",
      title: "Land of the Sweets",
      subtitle: "January 30 at 7 pm",
      caption: "UTEP's Magoffin Auditorium",
      buttonLink:
        "https://www.ticketmaster.com/land-of-the-sweets-el-paso-texas-01-30-2027/event/0C006536062E8731",
      buttonLabel: "RESERVE YOUR SEATS",
    },
  ];

  return (
    <div id="landOfTheSweets2027Div">
      <PerformanceTemplate
        status={status}
        showName={showName}
        showDate={showDate}
        headerDescription={headerDescription}
        auditionDate={auditionDate}
        performanceWeek={false}
        perfSect2ButtonLink={perfSect2ButtonLink}
        perfSect2Images={perfSect2Images}
        importantLinks={importantLinks}
        eventCalendar={eventCalendar}
        handbookLink={handbook}
        // perfSect2PerformanceWeekButtonLink={program}
      />
      <Footer />
    </div>
  );
}

export default LandOfSweets2027;
